import axios from "axios";

const axiosClient = axios.create({
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "X-CSRF-Token": document.querySelector("meta[name=\"csrf-token\"]").getAttribute("content"),
    "Content-Type": "application/json"
  },
});

export default axiosClient;
